import React, {Component} from "react";
import {Grid, Avatar, Hidden, Typography} from "@material-ui/core";
import Fab from "@material-ui/core/Fab/Fab";
import FormHelperText from "@material-ui/core/FormHelperText";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import InputMask from "react-input-mask";
import {
  primaryColor,
  textBlack,
  textPrimary,
  webFont
} from "../../config/theme";
import {compose, graphql} from "react-apollo";
import UPDATE_CHEF from "../../graphql/mutations/chef/update_chef";
import {connect} from "react-redux";
import Radio from "@material-ui/core/Radio";
import {UPDATE_CHEF_PAYOUT} from "../../graphql/mutations/chef";
//import {DatePicker, KeyboardDatePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import moment from "moment";
import {NotificationManager} from "react-notifications";
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import format from 'date-fns/format'
import {getChef, getUser} from "../../redux/user";
//import InputField from "../Field";
import { DOCUMENT_UPLOAD } from '../../config/constants';
import { checkValidDate } from '../../utils/validate-data';
import axios from "axios";
import style from "../../containers/ChefSetup/style";

const uploadErrMsg = "You can only upload images(JPG / PNG) or PDF files upto 10MB in size";

class FrDateFnsUtils extends DateFnsUtils {
  startOfMonth(date) {
    return moment(date).startOf('month').toDate();
  }

  getDatePickerHeaderText(date) {
    return format(date, 'MMM dd, yyyy', {locale: this.locale})
  }
}

class ChefPaymentInfo extends Component {
  constructor(props) {
    super(props);
    const chefDetails = props.chef || null;

    this.state = {
      hasValue: false,
      changesMade: false,
      uploadDocument: false,
      frontUploaded: chefDetails && !!chefDetails.identityDocuments && !!chefDetails.identityDocuments.front,
      backUploaded: chefDetails && !!chefDetails.identityDocuments && !!chefDetails.identityDocuments.back,
      initialState: {
        bankName: "",
        routingNumber: "",
        accountNumber: "",
        confirmAccountNumber: "",
        ssn: "",
      },
      errors: {
        bankName: "",
        routingNumber: "",
        accountNumber: "",
        confirmAccountNumber: "",
        dob: "",
        ssn: ""
      },
      selectedDate: props.chef && props.chef.dateOfBirth ? moment(props.chef.dateOfBirth).format('MM/DD/YYYY') : moment("01/01/1970").format('MM/DD/YYYY'),
      minDate:  moment().subtract(13, 'years').format('MM/DD/YYYY'),
      loading: false,
      datePickerRef: false,
      isDataDifferent: false
    };

  }

  updateChef() {
    let {chef} = this.props;

    const payoutMethod = chef && chef.payoutMethod ? chef.payoutMethod[0] : null;

    if (chef && payoutMethod)
      this.setState({
        initialState: {
          bankName: payoutMethod.bankName ? payoutMethod.bankName : '',
          routingNumber: payoutMethod.routingNumber ? payoutMethod.routingNumber : '',
          accountNumber: payoutMethod.last4 ? "XXXXXXXX" + payoutMethod.last4.substr(payoutMethod.last4.length - 4) : '',
          confirmAccountNumber: payoutMethod.last4 ? "XXXXXXXX" + payoutMethod.last4.substr(payoutMethod.last4.length - 4) : '',
          ssn: "XXXXX" + chef.taxId.substr(chef.taxId.length - 4)
        },
        selectedDate: chef.dateOfBirth ? moment(chef.dateOfBirth).format('MM/DD/YYYY') : '',
        frontUploaded: !!chef.identityDocuments && chef.identityDocuments.front,
        backUploaded: !!chef.identityDocuments && chef.identityDocuments.back,
      });
  }

  componentWillReceiveProps(nextProps, nextContext) {
    let {chef} = nextProps;
    const payoutMethod = chef && chef.payoutMethod ? chef.payoutMethod[0] : null;
    if (chef && payoutMethod) {
      this.setState({
        initialState: {
          bankName: payoutMethod.bankName ? payoutMethod.bankName : '',
          routingNumber: payoutMethod.routingNumber ? payoutMethod.routingNumber : '',
          accountNumber: payoutMethod.last4 ? "XXXXXXXX" + payoutMethod.last4.substr(payoutMethod.last4.length - 4) : '',
          confirmAccountNumber: payoutMethod.last4 ? "XXXXXXXX" + payoutMethod.last4.substr(payoutMethod.last4.length - 4) : '',
          ssn: "XXXXX" + chef.taxId.substr(chef.taxId.length - 4)
        },
        selectedDate: chef.dateOfBirth ? moment(chef.dateOfBirth).format('MM/DD/YYYY'): '',
        frontUploaded: !!chef.identityDocuments && chef.identityDocuments.front,
        backUploaded: !!chef.identityDocuments && chef.identityDocuments.back,
      });
    }
  }

  static getDerivedStateFromProps(props, state) {
    if (props.chef && !state.hasValue) {
      const payoutMethod = props.chef && props.chef.payoutMethod ? props.chef.payoutMethod[0] : null;
      const updateState = {
        frontUploaded: !!props.chef.identityDocuments && props.chef.identityDocuments.front ? true : false,
        backUploaded: !!props.chef.identityDocuments && props.chef.identityDocuments.back ? true : false,
        hasValue: true,
      };

      if (props.chef.dateOfBirth) {
        updateState.selectedDate = moment(props.chef.dateOfBirth).format('MM/DD/YYYY');
      }

      if (payoutMethod) {
        updateState.initialState = {
            bankName: payoutMethod.bankName ? payoutMethod.bankName : '',
            routingNumber: payoutMethod.routingNumber ? payoutMethod.routingNumber : '',
            accountNumber: payoutMethod.last4 ? "XXXXXXXX" + payoutMethod.last4.substr(payoutMethod.last4.length - 4) : '',
            confirmAccountNumber: payoutMethod.last4 ? "XXXXXXXX" + payoutMethod.last4.substr(payoutMethod.last4.length - 4) : '',
            ssn: "XXXXX" + props.chef.taxId.substr(props.chef.taxId.length - 4)
          };
      }

      return updateState;
    }

    return null;
  }

  async clearAll(){
    let {initialState}=this.state;
    initialState.ssn="";
    initialState.accountNumber="";
    initialState.confirmAccountNumber="";

    this.setState({
      initialState
    })
  }

  clearSSN() {
    let {initialState}=this.state;
    initialState.ssn="";

    this.setState({
      initialState
    })
  }

  clearSSNAccount() {
    let {initialState}=this.state;
    initialState.accountNumber="";
    initialState.confirmAccountNumber="";

    this.setState({
      initialState,
      isDataDifferent: true,
    })
  }

  clearSSNConfirmAccount() {
    let {initialState}=this.state;

    initialState.confirmAccountNumber="";

    this.setState({
      initialState,
      isDataDifferent: true
    })
  }

  componentDidMount() {
    const {userId, dispatch, isChef} = this.props;

    dispatch(getChef(userId));

    this.updateChef();
  }

  handleDocumentUpload = (files, type) => {
    this.setState({ uploadDocument: true });

    const frontDocInput = document.getElementById('frontDocument');
    const backDocInput = document.getElementById('backDocument');

    if (!files.length) {
      this.setState({ uploadDocument: false });
      return;
    }
    const doc = files[0];
    const fileType = doc.type;
    const size = doc.size;
    const allowedType = [
      'image/png',
      'image/jpeg',
      'application/pdf',
      'image/jpg'
    ];

    const mimeIndex = allowedType.findIndex(item => item === fileType);

    if (mimeIndex < 0) {
      this.setState({ uploadDocument: false });
      frontDocInput.value = '';
      backDocInput.value = '';
      NotificationManager.error(uploadErrMsg, "Document upload", 4000);
      return;
    }

    if (size > 10485760 || mimeIndex < 0) {
      this.setState({ uploadDocument: false });
      NotificationManager.error(uploadErrMsg, "Document upload", 4000);
      frontDocInput.value = '';
      backDocInput.value = '';
      return;
    }

    NotificationManager.info('Please do not close or navigate away from this page until upload finishes', 'Document upload', 4000);

    let formData = new FormData();
    const token = window.localStorage.getItem("ccZestyAuthToken");
    const userId = window.localStorage.getItem("zg-cc-auth-userId");

    formData.append("doc", doc);
    formData.append("documentType", type);
    formData.append("userId", userId);

    axios
      .post(DOCUMENT_UPLOAD, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Authorization": `Bearer ${token}`
        }
      })
      .then(response => {
        this.setState({ uploadDocument: false });

        if (type === 'front') {
          this.setState({ frontUploaded: true });
        }

        if (type === 'back') {
          this.setState({ backUploaded: true });
        }

        frontDocInput.value = '';
        backDocInput.value = '';
        NotificationManager.info(`Identity document ${type} uploaded successfully`, 'Document upload')
      })
      .catch(err => {
        this.setState({ uploadDocument: false });
        frontDocInput.value = '';
        backDocInput.value = '';
        console.log('ERROR: ', err);
        NotificationManager.error('There was an error uploading document. Please try again later.', 'Document upload');
      });
  }

  handleDateChange = async d => {
    this.setState({ changesMade: true, selectedDate: d });
    const inDate = d.replace(/\//g, '').replace(/\s/g, '').trim();
    let errors = this.state.errors;

    /*if (inDate.length < 8 ) {
      errors.dob = 'Enter valid date';
    } else {
      errors.dob = '';
    }*/

    if (errors.dob.length > 0 && inDate.length < 8) {
      await this.setState({selectedDate: d, errors: {...this.state.errors, ...errors}});
      return;
    }

    if (inDate.length > 7) {
      const selectedDate = moment(d);
      const checkDate = moment().subtract(18, 'year');
      const minDateMoment = moment('01 Jan 1900');

      if (selectedDate.isBefore(minDateMoment)) {
        errors.dob = 'Cannot be less than 01 Jan 1900'
      } else {
        errors.dob = "";
      }

      await this.setState({selectedDate: d});

      if (selectedDate.isBefore(checkDate)) {
        errors.dob = "";
      } else {
        errors.dob = 'You must be 18+'
      }



      await this.setState({errors: {...this.state.errors, ...errors}});
    } else {
      this.setState({ selectedDate: inDate });
    }
  };

  handleChange = (name, e) => {
    let errors = this.state.errors;
    let {initialState} = this.state;
    let re = /^[a-zA-Z ]+$/;

    this.setState({ changesMade: true });

    switch (name) {
      case "bankName":
        if (!e.target.value || e.target.value === '') {
          errors.bankName = 'Bank name is required';
        }
        else if (!re.test(e.target.value)) {
          errors.bankName = "Please enter a valid bank name";
        } else {
          errors.bankName = "";
        }
        initialState.bankName = e.target.value;
        break;
      case "routingNumber":
        if (
          (!e.target.value || e.target.value === '' || isNaN(e.target.value)) ) {
          errors.routingNumber = "Routing number is required";
        } if ( e.target.value.length !== 9) {
            errors.routingNumber = "Please enter a valid routing number (9 digits)";
        } else {
          errors.routingNumber = "";
        }
        initialState.routingNumber = e.target.value;
        break;
      case "accountNumber":
        if (
          (!e.target.value || e.target.value === '' || isNaN(e.target.value)) ||
          e.target.value.length < 6 || e.target.value.length > 17
        ) {
          errors.accountNumber = "Account number is required";
        } else if (e.target.value.length < 6 || e.target.value.length > 17) {
          errors.accountNumber = "Please enter a valid account number (6 to 17 digit)";
        } else {
          errors.accountNumber = "";
        }
        initialState.accountNumber = e.target.value;

        break;

      case "confirmAccountNumber":
        if (
          (!e.target.value || e.target.value === '' || isNaN(e.target.value)) ||
          e.target.value.length < 6 || e.target.value.length > 17
        ) {
          errors.confirmAccountNumber =
            "Account number does not matches";
        } else if (this.state.initialState.accountNumber !== e.target.value) {
          errors.confirmAccountNumber = "Account number does not matches";
        } else {
          errors.confirmAccountNumber = "";
        }
        initialState.confirmAccountNumber = e.target.value;
        break;
      case "ssn":
        let ssn = e.target.value;
        ssn = ssn.replace(/-/g, "");
        if (
          (!ssn || ssn === '' || isNaN(ssn))
        ) {
          errors.ssn = "SSN is required";
        } if (ssn.length != 9) {
          errors.ssn = "Please enter valid ssn number (max 9 numbers)";
      } else {
          errors.ssn = "";
        }
        initialState.ssn = ssn;

        break;
      default:
        return;
    }
    this.setState({errors: {...this.state.errors, ...errors}});
    this.setState({initialState: initialState, isDataDifferent: true});
  };

  submitDetail = async event => {
    event.preventDefault();
    const {updateChefPayoutMethod, updateChef} = this.props;
    let {selectedDate} = this.state;
    let chefPayload = "";
    let formData = event.target.elements;

    await this.handleDateChange(moment(selectedDate).format('MM/DD/YYYY'));

    if (!checkValidDate(moment(selectedDate).format('MM/DD/YYYY'))) {
      NotificationManager.error('Invalid Date', 'Payout Info.');
      return;
    }

    if (formData.accountNumber.value.includes('x') || formData.ssn.value.includes('x')) {
      this.clearAll();
      NotificationManager.error('Enter valid details', 'Payout Info.');
      return;
    }

    if (!formData.accountNumber.value
      || !formData.ssn.value
      || !formData.bankName.value
      || !selectedDate
      || !formData.routingNumber.value
      || !formData.confirmAccountNumber.value

    ) {
      NotificationManager.error('All fields are required', 'Payout Info.');
      return;
    }

    if (formData.accountNumber.value.startsWith('XX') || formData.confirmAccountNumber.value.startsWith('XX') || formData.ssn.value.startsWith('XX')) {
      NotificationManager.error('Please enter correct values for Account number and SSN', 'Payout Info.');
      return;
    }

    selectedDate = moment(selectedDate).format('MM-DD-YYYY');
    const dateRegex = /^((0|1)\d{1})-((0|1|2)\d{1})-((19|20)\d{2})$/;
    if (!dateRegex.test(selectedDate)) {
      let errors = this.state.errors;
      errors.dob = "Invalid date";
      this.setState({errors: {...this.state.errors, ...errors}});
      return;
    }

    if (this.validateDetails()) {
      let payload = {
        type: "ACH",
        achAccount: {
          bankName: formData.bankName.value,
          type: "CHECKING",
          routingNumber: formData.routingNumber.value,
          accountNumber: formData.accountNumber.value
        }
      };

      if (this.props.isChef) {

        if (selectedDate) {
          let errors = this.state.errors;
          let ssnVal = formData.ssn.value;

          chefPayload = {
            userId: this.props.userId,
            dateOfBirth: selectedDate,

          };

          ssnVal = ssnVal.replace(new RegExp('X', 'gi'), '');
          ssnVal = ssnVal.replace(new RegExp('-', 'gi'), '');

          if (ssnVal.length > 4) {
            if (ssnVal.length === 9 && !isNaN(ssnVal)) {
              chefPayload.taxId = ssnVal;
              errors.ssn = "";
            }
            else {
              NotificationManager.error('Please enter a valid SSN', 'Payout Info');
              errors.ssn = "Please enter a valid SSN";
              return;
            }
          }

          chefPayload.taxId = ssnVal;

          this.setState({loading: true});

          updateChef({
            variables: {chef: chefPayload}
          })
            .then(res => {

              updateChefPayoutMethod({
                variables: {chefId: this.props.chef.id, payout: payload}
              })
                .then(res => {
                  NotificationManager.info(
                    "Payout Info. updated successfully",
                    "Payout Info."
                  );

                  this.setState({loading: false, changesMade: false});
                })
                .catch(err => {
                  console.log(JSON.parse(JSON.stringify(err)));
                  let errorObj = JSON.parse(JSON.stringify(err));
                  if (errorObj.graphQLErrors) {
                    errorObj.graphQLErrors.map(error => {
                      NotificationManager.error(error.message, "Payout Info");
                    });
                  }
                  this.setState({loading: false});
                });

            })
            .catch(err => {
              console.log(JSON.parse(JSON.stringify(err)));
              let errorObj = JSON.parse(JSON.stringify(err));
              if (errorObj.graphQLErrors) {
                errorObj.graphQLErrors.map(error => {
                  NotificationManager.error(error.message, "Payout Info");
                });
              }
              this.setState({loading: false});
            });
        }
      }
    }
  };

  validateDetails() {
    let stateErrors = this.state.errors;
    let validated = true;
    for (let key in stateErrors) {
      if (stateErrors[key]) {
        validated = false;
      }

    }
    return validated;
  }

  toggleLoginDrawer = () => {
    this.setState({openLoginDrawer: !this.state.openLoginDrawer});
  };

  openDatePicker = e => {
    this.setState({datePickerRef: !this.state.datePickerRef})
  };

  render() {
    let {minDate, selectedDate} = this.state;
    const {initialState} = this.state;

    return (
      <div>
        <Typography variant={'h4'} style={{ fontFamily: webFont }}>Personal identity details</Typography>
        <Typography variant={'h5'} style={{ marginTop: 30, fontFamily: webFont }}>Upload identity document*</Typography>
        <Typography variant={'h6'} style={{ fontSize: 15, fontWeight: 300, fontFamily: webFont }}>This could be your passport or any valid US identity card. Please complete  uploading the front image of your identity document, before inputing the rest of the identity and payout information.</Typography>
        <Grid container justify={"space-between"} style={{ marginTop: 50 }}>
          <Grid item xs={12} sm={6}>
            <input
              disabled={this.state.uploadDocument}
              type="file"
              accept="image/png, image/jpeg, application/pdf"
              name="frontDocument"
              id="frontDocument"
              style={{ display: "none" }}
              onChange={data => this.handleDocumentUpload(data.target.files, 'front')} />
            {this.state.frontUploaded ? (
              <Fab
                data-test-id={"frontDocUpload"}
                variant={"extended"}
                disabled={this.props.loading || this.state.uploadDocument}
                type="button"
                style={
                  this.props.loading || this.state.uploadDocument
                    ? style.submitButtonDisabled
                    : style.submitButton
                }
                onClick={() => document.getElementById('frontDocument').click()}
              >
                Update front image
              </Fab>
            ) : (<Fab
              data-test-id={"frontDocUpload"}
              variant={"extended"}
              disabled={this.props.loading || this.state.uploadDocument || this.state.frontUploaded}
              type="button"
              style={
                this.props.loading || this.state.uploadDocument || this.state.frontUploaded
                  ? style.submitButtonDisabled
                  : style.submitButton
              }
              onClick={() => document.getElementById('frontDocument').click()}
            >
              Upload front image
            </Fab>)}
          </Grid>
          <Grid item xs={12} sm={6} style={{ paddingLeft: 5 }}>
            <input
              disabled={this.state.uploadDocument}
              type="file"
              accept="image/png, image/jpeg, application/pdf"
              name="backDocument"
              id="backDocument"
              style={{ display: "none" }}
              onChange={data => this.handleDocumentUpload(data.target.files, 'back')} />
            {
              this.state.backUploaded ? (<Fab
                data-test-id={"backDocUpload"}
                variant={"extended"}
                disabled={this.props.loading || this.state.uploadDocument}
                type="button"
                style={
                  this.props.loading || this.state.uploadDocument
                    ? style.submitButtonDisabled
                    : style.submitButton
                }
                onClick={() => document.getElementById('backDocument').click()}
              >
                Update back image
              </Fab>) : (
                <div className="payout-back-optional">
                  <span className="optional-message">(Optional)</span>
                  <Fab
              data-test-id={"backDocUpload"}
              variant={"extended"}
              disabled={this.props.loading || this.state.uploadDocument || this.state.backUploaded}
              type="button"
              style={
                this.props.loading || this.state.uploadDocument || this.state.backUploaded
                  ? style.submitButtonDisabled
                  : style.submitButton
              }
              onClick={() => document.getElementById('backDocument').click()}
            >
              Upload back image
            </Fab>
                </div>)
            }
          </Grid>
        </Grid>
        <form onSubmit={this.submitDetail}>
          <Grid container spacing={16}>
            <Grid item md={12} style={{ marginTop: 20 }} />
            <Grid item md={6} xs={12} style={styles.commonTop}>
              <Grid>
                <InputLabel style={styles.ftText} onClick={this.openDatePicker.bind(this)}>DATE OF
                  BIRTH</InputLabel>



                {/*<MuiPickersUtilsProvider utils={FrDateFnsUtils}>
                  <KeyboardDatePicker
                    margin="normal"
                    style={{...styles.inputText, color: primaryColor, display: "none"}}
                    value={new Date(selectedDate)}
                    animateYearScrolling
                    id="date-picker-dialog"
                    onChange={this.handleDateChange}
                    maxDate={minDate}
                    onAccept={(d) => {
                      // this.openDatePicker();
                    }}
                    onClose={() => {
                      this.openDatePicker();
                    }}
                    onOpen={() => this.openDatePicker()}
                    format="MM/dd/yyyy"
                    style={styles.inputText}
                    open={this.state.datePickerRef}
                  />
                </MuiPickersUtilsProvider>*/}
                <InputMask
                  mask={"99/99/9999"}
                  name={"dateOfBirth"}
                  maskChar={" "}
                  style={styles.inputText}
                  placeholder={"MM/DD/YYYY"}
                  value={selectedDate}
                  onChange={e => this.handleDateChange(e.target.value)}
                  onBlur={() => this.handleDateChange(selectedDate)}
                >
                  {inputProps => <Input {...inputProps} type={"text"} />}
                </InputMask>

              </Grid>
              <FormHelperText id="component-error-text" style={styles.error}>
                {this.state.errors.dob}
              </FormHelperText>
            </Grid>
            <Grid item md={6} xs={12} style={styles.commonTop}>
              <InputLabel style={styles.ftText}>SSN</InputLabel>
              <InputMask
                mask={"***-**-9999"}
                name={"ssn"}
                maskChar={" "}
                style={styles.ssnInput}
                placeholder={"000-00-000"}
                value={initialState.ssn}
                onClick={this.clearSSN.bind(this)}
                onChange={e => {
                  this.handleChange("ssn", e);
                }}
              >
                {inputProps => <Input {...inputProps} type={"text"} />}
              </InputMask>
              <FormHelperText id="component-error-text" style={styles.error}>
                {this.state.errors.ssn}
              </FormHelperText>
            </Grid>

            <Grid item md={12}>
              <Typography variant={'h4'} style={{ marginTop: 40, marginBottom: 15, fontFamily: webFont }}>Banking details</Typography>
              {/*<Typography variant={'h6'} style={{ fontSize: 15, fontWeight: 300, marginBottom: 30 }}>These details are needed for Payouts</Typography>*/}
            </Grid>
            <Grid item md={6} xs={12} style={styles.commonTop}>
              <InputLabel style={styles.ftText}>BANK NAME</InputLabel>
              <Input
                name={"bankName"}
                placeholder={"Enter Bank Name"}
                label={"BANK NAME"}
                type={"text"}
                value={initialState.bankName}
                onChange={e => {
                  this.handleChange("bankName", e);
                }}
                style={styles.inputText}
              />
              <FormHelperText id="component-error-text" style={styles.error}>
                {this.state.errors.bankName}
              </FormHelperText>
            </Grid>
            <Grid item md={6} xs={12} style={styles.commonTop}>
              <InputLabel style={styles.ftText}>ROUTING NUMBER</InputLabel>
              <Input
                name={"routingNumber"}
                placeholder={"Enter Routing Number"}
                label={"ROUTING NUMBER"}
                type={"text"}
                value={initialState.routingNumber}
                onChange={e => {
                  this.handleChange("routingNumber", e);
                }}
                style={styles.inputText}
              />
              <FormHelperText id="component-error-text" style={styles.error}>
                {this.state.errors.routingNumber}
              </FormHelperText>
            </Grid>
            <Grid item md={6} xs={12} style={styles.commonTop}>
              <InputLabel style={styles.ftText}>ACCOUNT NUMBER</InputLabel>
              <Input
                name={"accountNumber"}
                placeholder={"Account Number"}
                label={"ACCOUNT NUMBER"}
                type={"text"}
                onClick={this.clearSSNAccount.bind(this)}
                value={initialState.accountNumber}
                onChange={e => {
                  this.handleChange("accountNumber", e);
                }}
                style={styles.inputText}
              />
              <FormHelperText id="component-error-text" style={styles.error}>
                {this.state.errors.accountNumber}
              </FormHelperText>
            </Grid>
            <Grid item md={6} xs={12} style={styles.commonTop}>
              <InputLabel style={styles.ftText}>
                CONFIRM ACCOUNT NUMBER
              </InputLabel>
              <Input
                name={"confirmAccountNumber"}
                placeholder={"Confirm Account Number"}
                label={"CONFIRM ACCOUNT NUMBER"}
                type={"text"}
                value={initialState.confirmAccountNumber}
                onClick={this.clearSSNConfirmAccount.bind(this)}
                onChange={e => {
                  this.handleChange("confirmAccountNumber", e);
                }}
                style={styles.inputText}
              />
              <FormHelperText id="component-error-text" style={styles.error}>
                {this.state.errors.confirmAccountNumber}
              </FormHelperText>
            </Grid>

            <Grid item md={6} xs={12} style={styles.commonTop}>
              <div>
                <InputLabel style={styles.ftText}>ACCOUNT TYPE</InputLabel>
                <br/>
                <div>
                  <Radio color="primary" value="checking" checked/> Checking
                </div>
              </div>
            </Grid>
            <Grid item md={6}/>

            <Grid
              container
              alignItems="flex-start"
              justify="flex-start"
              direction="row"
              style={{ marginTop: 40 }}
            >
              <Hidden smUp>
                <Grid item xs={8}>
                  <Fab
                    variant={"extended"}
                    disabled={this.props.loading}
                    type="submit"
                    style={styles.submitButton}
                  >
                    Save
                  </Fab>
                </Grid>
                <Grid item xs={2}/>
              </Hidden>
              <Hidden xsDown>
                <Grid item md={11} style={{display: 'flex', justifyContent: 'flex-end', paddingRight: 10}}>
                  <Fab
                    variant={"extended"}
                    disabled={this.props.loading || !this.state.changesMade}
                    type="submit"
                    style={styles.submitButton}
                  >
                    {this.state.loading && (
                      <CircularProgress
                        color={"primary"}
                        style={{color: "white", height: 30, width: 30}}
                      />
                    )}
                    {!this.state.loading && "Save"}
                  </Fab>
                </Grid>
              </Hidden>
            </Grid>
          </Grid>
        </form>
      </div>
    );
  }
}

const mapSateToProps = state => {
  return {
    userId: state.auth.userId,
    isChef: state.auth.isChef,
    diner: state.user.diner,
    chef: state.user.chef
  };
};
const ChefPaymentInfoWithData = compose(
  graphql(UPDATE_CHEF, {name: "updateChef"}),
  graphql(UPDATE_CHEF_PAYOUT, {name: "updateChefPayoutMethod"})
)(ChefPaymentInfo);
const UpdateChefPaymentInfo = connect(mapSateToProps)(ChefPaymentInfoWithData);

export default UpdateChefPaymentInfo;

const styles = {
  avatarImg: {
    width: "86px",
    height: "86px",
    borderColor: primaryColor,
    borderWidth: 7
  },

  userName: {
    fontFamily: webFont,
    fontSize: "30px",
    color: textBlack,
    weight: 500,
    paddingLeft: 0,
    textAlign: "left"
  },

  ftText: {
    fontFamily: webFont,
    fontSize: "15px",
    color: textBlack,
    marginLeft: 80,
    fontWeight: 500,
    marginTop: 15,
  },
  frlabel: {
    fontFamily: webFont,
    fontSize: "20px",
    color: textPrimary,
    marginLeft: 80,
    fontWeight: 500,
    marginBottom: 30,
    marginTop: 30
  },
  inputText: {
    fontFamily: webFont,
    fontSize: "18px",
    width: "80%",
    height: "62%",
  },
  ssnInput: {
    fontFamily: webFont,
    fontSize: "18px",
    width: "80%",
  },
  setFont: {
    fontFamily: webFont
  },

  showBtn: {
    borderRadius: 40,
    paddingLeft: 20,
    paddingRight: 20
  },
  displayBlock: {
    display: "block"
  },
  displayNone: {
    display: "none"
  },
  error: {fontSize: 12, color: "red", fontFamily: webFont},
  submitButton: {
    borderRadius: 25,
    backgroundColor: primaryColor,
    border: "none",
    minWidth: 200,
    color: "white",
    height: 49,
    fontFamily: webFont,
    textTransform: "none",
    fontWeight: "normal",
    boxShadow: 'none',
    fontSize: 18,
  },
  commonTop: {
    marginTop: 15,
  },
  commonTopDOB: {
    marginTop: 25,
  },
};
